import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { pricingPlans } from './Data';
import "./PricingCard.css";
import PricingItem from "./PricingItem";
import posthog from 'posthog-js';

const PricingCard = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    useEffect(() => {
        const savedY = sessionStorage.getItem("pricing-page-scroll");
        if (savedY) {
            window.scrollTo(0, Number(savedY));
            sessionStorage.removeItem("pricing-page-scroll");
        }

        const grid = document.querySelector('.pricingCardGrid');
        const savedX = sessionStorage.getItem("pricing-grid-scroll");
        if (grid && savedX) {
            grid.scrollLeft = Number(savedX);
            sessionStorage.removeItem("pricing-grid-scroll");
        }
    }, []);

   const showPricingCards = posthog.isFeatureEnabled("pricing_section");

   if (!showPricingCards) return null;

    return (
        <section className="pricingSection">
            <motion.div
                className="pricingContent"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7 }}
            >
                <h1 className="pricingMainHeading">
                    Flexible pricing for every need <br/>
                    <span className="pricingSpan">choose the perfect plan for you.</span>
                </h1>

                <p className="pricingPara">
                    Plans Designed to Help You Succeed at Every Level.
                </p>
            </motion.div>

            <div className="pricingCardContainer">
                <motion.div
                    className="pricingCardGrid"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                >
                    {pricingPlans.map((plan, index) => (
                        <motion.div
                            key={plan.id}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{
                                duration: 0.6,
                                delay: index * 0.15,
                                ease: "easeOut"
                            }}
                        >
                            <PricingItem plan={plan} />
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default PricingCard;
